import { useState } from "react";

import { ModalSelector } from "molecules/containers/modal-selector-list/entry/ModalSelector";
import { ListModalSize } from "molecules/modal-window/list-modal/ListModal";
import { ListModal } from "molecules/modal-window/list-modal/ListModal";
import { uniqueBy } from "toolbox/Array";
import pluralize from "utils/pluralize";

type SelectModalProps = {
  open?: boolean;
  onClose: () => void;
  title: string;
  size?: ListModalSize;
  items: {
    unitType: string;
    quantity: number;
    id: string;
    name: string;
  }[];
  numberOfSelections: number;
  onFirstButtonClick: (selectedInclusions: string[]) => void;
  firstButtonLabel: string;
  onSecondButtonClick: () => void;
  secondButtonLabel: string;
  itemType: "reward" | "offer";
};

export const FreeServiceSelector = ({
  open,
  onClose,
  title,
  size,
  items,
  onFirstButtonClick,
  firstButtonLabel,
  onSecondButtonClick,
  secondButtonLabel,
  numberOfSelections,
  itemType,
}: SelectModalProps) => {
  const [services, setServices] = useState(
    items.map((item) => ({ ...item, disabled: false }))
  );
  const [selectedServices, setSelectedServices] = useState<string[]>([]);

  const subtitleContent = () => {
    return (
      <div className="p-4 pb-3 text-center">
        <span className="text-bold1">Select {numberOfSelections}</span> free{" "}
        {pluralize(numberOfSelections, "service", "services")} for your{" "}
        {itemType}
      </div>
    );
  };

  const firstButtonDisabled = numberOfSelections !== selectedServices.length;

  const onSelect = (value: boolean, id: string) => {
    // Update selectedServices
    const updatedSelectedServices = value
      ? uniqueBy([...selectedServices, id])
      : selectedServices.filter((item) => item !== id);
    setSelectedServices(updatedSelectedServices);

    // Update services disabled status
    setServices((prev) => {
      return prev.map((item) => {
        return updatedSelectedServices.length >= numberOfSelections
          ? {
              ...item,
              disabled: !updatedSelectedServices.includes(item.id),
            }
          : { ...item, disabled: false };
      });
    });
  };

  const onSubmit = () => {
    onFirstButtonClick(selectedServices);
  };

  const modalProps = {
    open,
    onClose,
    size,
    title,
    firstButtonLabel,
    secondButtonLabel,
    onSecondButtonClick,
    onFirstButtonClick: onSubmit,
    firstButtonDisabled,
  };

  return (
    <ListModal {...modalProps}>
      {subtitleContent()}
      <div className="px-4">
        {services?.map((service) => {
          return (
            <ModalSelector
              key={service.id}
              tag={null}
              title={service.name || ""}
              checked={selectedServices?.includes(service.id)}
              description={null}
              onChange={(value: boolean) => {
                onSelect(value, service.id);
              }}
              label={null}
              type={"checkbox"}
              subtitle={`${service?.quantity} ${service?.unitType}`}
              disabled={service.disabled}
            />
          );
        })}
      </div>
    </ListModal>
  );
};
